import { ApiRes, api } from '@src/utils/api/client'

export interface TransmitAssetListResponse {
    success: boolean
    assets_count: number
    assets: TransmitAssetListItem[]
}

export interface TransmitAssetListItem {
    asset_uid: string
    asset_title: string
    total_shares: number
}

export const getTransmitAssetList = (
    platformName: string,
    accountId: string
): ApiRes<TransmitAssetListResponse> => {
    return api.get(
        `v2/manage/transmit-asset/assets/${platformName}/${accountId}/list`
    )
}

export const getTransmitAccountList = (
    platformName: string,
    accountId: string,
    search: string
): ApiRes<TransmitAssetListResponse> => {
    return api.get(
        `v2/manage/transmit-asset/accounts/${platformName}/${accountId}/list?search=${search}`
    )
}

export const transmitAsset = (
    accountId: string,
    assetId: string,
    transmitAssetList: [],
    ticketLink: string
): ApiRes<TransmitAssetListResponse> => {
    return api.post('v2/manage/transmit-asset/transmit', {
        accountId: accountId,
        assetId: assetId,
        transmitAssetList: transmitAssetList,
        ticketLink: ticketLink,
    })
}
